import React from 'react';
import PropTypes from 'prop-types';
import ComponentWithPopover from '../componentWithPopopver/ComponentWithPopover';
import './DisableComponentWithPopover.scss';

const DisableComponentWithPopover = props => {
    const popoverRef = React.createRef();

    const handleOnBlur = () => {
        if (popoverRef.current) popoverRef.current.hide();
    };

    const { className, popoverMessage, disabled, children, popperConfig } = props;

    return (
        <div className={`disabled-component ${className}`}>
            {disabled ? (
                <ComponentWithPopover
                    message={popoverMessage}
                    className="nav-popover"
                    ref={popoverRef}
                    popperConfig={popperConfig}
                >
                    <div
                        className="disabled-component-children"
                        tabIndex={-1}
                        onBlur={handleOnBlur}
                    >
                        {children}
                    </div>
                </ComponentWithPopover>
            ) : (
                children
            )}
        </div>
    );
};

DisableComponentWithPopover.defaultProps = {
    className: '',
    popoverMessage: '',
    disabled: false,
    children: null,
    popperConfig: {},
};

DisableComponentWithPopover.propTypes = {
    className: PropTypes.string,
    popoverMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    disabled: PropTypes.bool,
    children: PropTypes.object,
    popperConfig: PropTypes.object,
};

export default DisableComponentWithPopover;
